import { Disclosure } from '@headlessui/react';
import { Fragment, useEffect } from 'react';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';
import InnerCheckbox from '../../../Disciplines/components/exercises/components/innerCheckbox';
import { practiceRevisionFilterStore } from '../../stores/practiceRevisionFilterStore';
import { practiceStore } from '../../stores/practiceStore';
import { format } from 'date-fns';
import { auxiliarStore } from '../../stores/auxiliarStore';
import { useGetPractices } from '../../hooks/getPractice';
import { LoadingIcon } from 'morpheus-ui';

interface IModalFilter {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function ModalFilterRevision({
  isOpen,
  onClose,
  onSubmit,
}: IModalFilter) {
  const { discipline, list, exam, setDiscipline, setList, setExam, reset } =
    practiceRevisionFilterStore();
  const { isLoading, mutate } = useGetPractices();
  const { practice } = practiceStore();
  const { areas } = auxiliarStore();

  const resetAll = () => {
    reset();
    onSubmit();
  };

  const handleChange = (value: string, type: string) => {
    let aux: string[] = [];

    if (type === 'discipline') {
      aux = [...discipline];
    }

    if (type === 'exam') {
      aux = [...exam];
    }

    if (type === 'list') {
      aux = [...list];
    }

    const idx = aux.findIndex((it) => it === value);

    if (idx >= 0) {
      aux.splice(idx, 1);
    } else {
      aux.push(value);
    }

    if (type === 'discipline') {
      setDiscipline(aux);
    }

    if (type === 'list') {
      setList(aux);
    }

    if (type === 'exam') {
      setExam(aux);
    }
  };

  const applyFilters = () => {
    onSubmit();
  };

  useEffect(() => {
    if (!practice || practice.length === 0) {
      mutate();
    }
  }, []);

  return (
    <Modal
      position={window.innerWidth < 768 ? 'bottom' : 'top-right'}
      size='md'
      isOpen={isOpen}
      onClose={() => onClose()}
      className='xs:h-[90vh] xs:w-full sm:h-[75vh] md:h-[95vh] md:w-[35%]'
      title='Filtrar revisões'
    >
      <div
        id='filterContainer'
        className='flex w-full flex-col gap-md overflow-x-auto px-2 py-2 xs:h-[58vh] sm:h-[48vh] md:h-[75vh]'
      >
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Disciplinas
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} text-mono-color-black h-5 w-5`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                {areas &&
                  areas.areas &&
                  areas.areas.length > 0 &&
                  areas.areas.map((it) => (
                    <InnerCheckbox
                      key={it.id}
                      onChange={() => handleChange(it.id, 'discipline')}
                      label={it.title}
                      checked={discipline.includes(it.id)}
                      id={`disciplines-practice-${it.title}`}
                      value={it.id}
                    />
                  ))}
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='border-mono-color-lightest w-full border-b-hairline' />
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Simulados
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} text-mono-color-black h-5 w-5`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                {isLoading ? (
                  <LoadingIcon className='h-10 animate-spin fill-none stroke-current text-center' />
                ) : (
                  <Fragment>
                    {practice &&
                      practice.length > 0 &&
                      practice
                        .filter((it) => it.finished)
                        .map((it, i) => (
                          <InnerCheckbox
                            key={i}
                            onChange={() => handleChange(it._id, 'exam')}
                            label={
                              it.title ||
                              'Simulado - ' +
                                format(new Date(it.createdAt), 'dd/MM/yyyy')
                            }
                            checked={exam.includes(it._id)}
                            id={`practice-revision-exam-${it._id}`}
                            value={it._id}
                          />
                        ))}
                  </Fragment>
                )}
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='border-mono-color-lightest w-full border-b-hairline' />
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Lista
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} text-mono-color-black h-5 w-5`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleChange('now', 'list')}
                  label='Revise agora'
                  checked={list.includes('now')}
                  id='practice-revision-list-now'
                  value='now'
                />
                <InnerCheckbox
                  onChange={() => handleChange('after', 'list')}
                  label='Próximas revisões'
                  checked={list.includes('after')}
                  id='practice-revision-list-after'
                  value='now'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='border-mono-color-lightest w-full border-b-hairline' />
      </div>
      <div className='fixed bottom-0 left-0 flex w-full flex-row items-center justify-center gap-lg px-4 py-5'>
        <Button
          variant='text'
          className='w-1/2 xs:text-sm md:text-md'
          full
          onClick={() => resetAll()}
        >
          <Icon Icon='delete' type='material' className='text-sm' />
          Limpar seleção
        </Button>
        <Button
          className='w-1/2 xs:text-sm md:text-md'
          full
          onClick={() => applyFilters()}
        >
          Aplicar filtros
        </Button>
      </div>
    </Modal>
  );
}
